module.exports = __webpack_public_path__ + "static/media/temperature.4001069e.svg";